import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import AdminLink from "./adminLink";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";

function LabSettings({ labcode }) {
  const [loader, setLoader] = useState(true);
  const [isAhcEnabled, setIsAhcEnabled] = useState(false);
  const [isPemeEnabled, setIsPemeEnabled] = useState(false);
   const token = JSON.parse(localStorage.getItem("data")).token;

  const [labDetails, setLabDetails] = useState(null);

  const navigate = useNavigate();

  const getData = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      const response = await axios.get(`/api/labdetails/labcode=${labcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabDetails(response.data);
      // Optionally initialize toggles from fetched data
      setIsAhcEnabled(response.data?.ahc);
      setIsPemeEnabled(response.data?.peme);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handleToggleChange = async (type, value) => {
    setLoader(true);
  
    // Update local state immediately
    if (type === "ahc") {
      setIsAhcEnabled(value);
    } else if (type === "peme") {
      setIsPemeEnabled(value);
    }
  
    try {
      // Send updated values in the API request
      const payload = {
        id: labDetails.id,
        ahc: type === "ahc" ? value : isAhcEnabled, // Ensure correct value is sent
        peme: type === "peme" ? value : isPemeEnabled,
      };
  
      await axios.post(`/api/labdetails/update`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      toast.success(`${type.toUpperCase()} status updated successfully!`);
  
      // Fetch latest data from API to keep UI in sync
      getData();
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };
  
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return (
      <div>
        <div className="company-profile">
          <div className="card card-raised mb-5">
            <div className="card-body">
              <div className="card-title form-group d-flex align-items-center justify-content-between">
                <span>Lab Settings</span>
              </div>
              <br />
              <div className="row">
            {/* AHC Toggle */}
            <div className="col-md-4">
              <div className="form-floating-sm mb-2">
                <label></label>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="ahcToggle"
                    checked={isAhcEnabled}
                    onChange={(e) => handleToggleChange("ahc", e.target.checked)}
                    style={{ cursor: "pointer" }}
                    title={isAhcEnabled ? "Disable AHC Status" : "Enable AHC Status"}
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor="ahcToggle"
                    style={{ cursor: "pointer" }}
                    title={isAhcEnabled ? "Disable AHC Status" : "Enable AHC Status"}
                  >
                    {isAhcEnabled ? "AHC Enabled" : "AHC Disabled"}
                  </label>
                </div>
              </div>
            </div>

            {/* PEME Toggle */}
            <div className="col-md-4">
              <div className="form-floating-sm mb-2">
                <label></label>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="pemeToggle"
                    checked={isPemeEnabled}
                    onChange={(e) => handleToggleChange("peme", e.target.checked)}
                    style={{ cursor: "pointer" }}
                    title={isPemeEnabled ? "Disable PEME Status" : "Enable PEME Status"}
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor="pemeToggle"
                    style={{ cursor: "pointer" }}
                    title={isPemeEnabled ? "Disable PEME Status" : "Enable PEME Status"}
                  >
                    {isPemeEnabled ? "PEME Enabled" : "PEME Disabled"}
                  </label>
      </div>
    </div>
  </div>
  </div>

</div>
</div>
        </div>
        {loader && <div className="loading"></div>}
      </div>
     );
}

export default LabSettings;
